/**
 * AgentEnquiryAgents
 * 
 * @Author: Focci
 * @Date: 2024-01-17 10:30:07
 * @Last Modified by: Focci
 * @Last Modified time: 2024-01-17 10:30:07
 */

import AgentHorizontal from '@comp/page/property/agent-card/AgentHorizontal'
import PropTypes from 'prop-types'

export default function AgentEnquiryAgents({
  agents = [],
  house
}) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
      {agents.map((agent) => (
        <AgentHorizontal
          size={90}
          bordered={false}
          nameClassname="text-f.8"
          agent={agent} 
          key={agent.id} 
          house={house}
          trackParams={{ agencyOfficeId: agent.officeId }}
        />
      ))}
    </div>
  )
}

AgentEnquiryAgents.propTypes = {
  agents: PropTypes.array,
  house: PropTypes.object,
}
